export enum ConfigurationRight {
  WRITE = 'WRITE',
  REQUEST = 'REQUESTED'
}
